/**
 * Size chart modal: opens dialog with chart image (Lunam block).
 */
(function () {
  function triggerFor(modal) {
    if (!modal || !modal.id) return null;
    return document.querySelector(
      '[data-lunam-sc-trigger][aria-controls="' + modal.id + '"]'
    );
  }

  function closeModal(modal) {
    if (!modal) return;
    var trig = triggerFor(modal);
    if (trig) trig.setAttribute('aria-expanded', 'false');
    modal.classList.remove('is-open');
    modal.hidden = true;
    if (!document.querySelector('[data-lunam-sc-root].is-open')) {
      document.documentElement.classList.remove('lunam-sc-modal-active');
    }
  }

  function openModal(modal) {
    if (!modal) return;
    document.querySelectorAll('[data-lunam-sc-root].is-open').forEach(function (m) {
      if (m !== modal) closeModal(m);
    });
    var trig = triggerFor(modal);
    if (trig) trig.setAttribute('aria-expanded', 'true');
    modal.hidden = false;
    requestAnimationFrame(function () {
      modal.classList.add('is-open');
    });
    document.documentElement.classList.add('lunam-sc-modal-active');
  }

  document.addEventListener('click', function (e) {
    var trig = e.target.closest('[data-lunam-sc-trigger]');
    if (trig) {
      e.preventDefault();
      var id = trig.getAttribute('aria-controls');
      var modal = id ? document.getElementById(id) : null;
      if (!modal) return;
      if (modal.classList.contains('is-open')) {
        closeModal(modal);
      } else {
        openModal(modal);
      }
      return;
    }
    if (!e.target.closest('[data-lunam-sc-close]')) return;
    var root = e.target.closest('[data-lunam-sc-root]');
    closeModal(root);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-lunam-sc-root].is-open').forEach(closeModal);
  });
})();
